export const appid = 180308;


// WEBPACK FOOTER //
// ./src/js/common/config.js